import dynamic from "next/dynamic";

const PannellumViewer = dynamic(
  () => import("components/elements/PannellumViewer/PannellumViewer"),
  { ssr: false },
);

const PannellumViewerHost = () => <PannellumViewer />;

export default PannellumViewerHost;
